import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import Footer from '../footer/footer';
import ButtonCard from '../card-button/card-button';
import CardBody from '../card-body/card-body';

const useStyles = makeStyles({
	root: {
		maxWidth: 220,
	}
});

const CustomCard = ({ cards }) => {

	const classes = useStyles();

	const elements = cards.map((item) => {

		const {id, cpUrl, ...bodyData} = item;
			
		return (
			<Grid key={id} item xs={6} sm={3} lg={2} className={classes.root}>
				<CardBody {...bodyData}/>
				<ButtonCard dataUrl={cpUrl}/>
			</Grid>
		);
	  })
	
    return (
		<Grid container spacing={2} justify="center">
			{ elements }
			<Grid item xs={12}>
				<Footer />
			</Grid>
		</Grid>
    );
  }

export default CustomCard;